import { deleteCookie, getCookie, setCookie, OptionsType } from 'cookies-next';
import { isCloudQueryDomain } from 'shared/base';

export function isCloudQueryUser(userEmail: string | undefined) {
  return userEmail?.endsWith('@cloudquery.io');
}

const key = 'user-selected-team-name';
function getCookieOptions(): OptionsType {
  return {
    domain: isCloudQueryDomain({ url: window.location.href }) ? '.cloudquery.io' : undefined,
    maxAge: 60 * 60 * 24 * 365, // 365 days
    path: '/',
    sameSite: 'lax',
  };
}

export function saveUserSelectedTeam(teamName: string | null | undefined) {
  if (teamName) {
    setCookie(key, teamName, getCookieOptions());
  } else {
    deleteCookie(key, getCookieOptions());
  }
}

export function getUserSelectedTeam(): string | undefined {
  return getCookie(key, getCookieOptions())?.toString();
}
